import { render, staticRenderFns } from "./CustomerServiceGridRow.vue?vue&type=template&id=1c15c504&scoped=true"
import script from "./CustomerServiceGridRow.vue?vue&type=script&lang=js"
export * from "./CustomerServiceGridRow.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceGridRow.vue?vue&type=style&index=0&id=1c15c504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c15c504",
  null
  
)

export default component.exports